import React from "react";
import "./Ranking.scss";

const Ranking = () => {
  return (
    <div className="">
      <div className="ranking-container customScroller-transparent">
        <h3>Ranking</h3>
        <p>Your brand is ranked on number 7</p>
        <div className="tableSet">
          <table class="brand-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Brand Name</th>
                <th>Country</th>
                <th>Total Visitors</th>
                <th>Bounce Rate</th>
                <th>Since</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="clrset">1</td>
                <td className="clrsetBlack">Trader Joe’s</td>
                <td className="clrset">Russia</td>
                <td className="clrset">150K</td>
                <td className="clrset">39%</td>
                <td className="clrset">2002</td>
              </tr>
              <tr>
                <td className="clrset">2</td>
                <td className="clrsetBlack">The Walt Disney Company</td>
                <td className="clrset">China</td>
                <td className="clrset">147K</td>
                <td className="clrset">44%</td>
                <td className="clrset">2001</td>
              </tr>
              <tr>
                <td className="clrset">3</td>
                <td className="clrsetBlack">Headspace</td>
                <td className="clrset">Japan</td>
                <td className="clrset">140K</td>
                <td className="clrset">45%</td>
                <td className="clrset">2019</td>
              </tr>
              <tr>
                <td className="clrset">4</td>
                <td className="clrsetBlack">Nintendo</td>
                <td className="clrset">Japan</td>
                <td className="clrset">140K</td>
                <td className="clrset">45%</td>
                <td className="clrset">2019</td>
              </tr>
              <tr>
                <td className="clrset">5</td>
                <td className="clrsetBlack">Uniqlo</td>
                <td className="clrset">USA</td>
                <td className="clrset">139K</td>
                <td className="clrset">48%</td>
                <td className="clrset">2002</td>
              </tr>
              <tr>
                <td className="clrset">6</td>
                <td className="clrsetBlack">The Walt Disney Company</td>
                <td className="clrset">UK</td>
                <td className="clrset">130K</td>
                <td className="clrset">49%</td>
                <td className="clrset">2002</td>
              </tr>
              <tr className="active">
                <td className="clrset">7</td>
                <td className="clrsetBlack">Nintendo</td>
                <td className="clrset">Korea</td>
                <td className="clrset">120K</td>
                <td className="clrset">49.5%</td>
                <td className="clrset">2020</td>
              </tr>
              <tr>
                <td className="clrset">8</td>
                <td className="clrsetBlack">Headspace</td>
                <td className="clrset">Brazil</td>
                <td className="clrset">110K</td>
                <td className="clrset">50.3%</td>
                <td className="clrset">2011</td>
              </tr>
              <tr>
                <td className="clrset">9</td>
                <td className="clrsetBlack">Nintendo</td>
                <td className="clrset">China</td>
                <td className="clrset">120K</td>
                <td className="clrset">49.5%</td>
                <td className="clrset">2020</td>
              </tr>
              <tr>
                <td className="clrset">10</td>
                <td className="clrsetBlack">The Walt Disney Company</td>
                <td className="clrset">UK</td>
                <td className="clrset">130K</td>
                <td className="clrset">49%</td>
                <td className="clrset">2002</td>
              </tr>
              <tr>
                <td className="clrset">11</td>
                <td className="clrsetBlack">Uniqlo</td>
                <td className="clrset">Brazil</td>
                <td className="clrset">110K</td>
                <td className="clrset">50.3%</td>
                <td className="clrset">2011</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pagination-box">
          <ul class="pagination">
            <li>
              <a href="#" aria-label="Previous" className="next">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.975 22L17.75 20.225L9.525 12L17.75 3.775L15.975 2L5.975 12L15.975 22Z"
                    fill="#9C3B3C"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a href="#" className="active">
                1
              </a>
            </li>
            <li>
              <a href="#">2</a>
            </li>
            <li>
              <a href="#">3</a>
            </li>
            <li>
              <a href="#" aria-label="Next" className="next">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z"
                    fill="#9C3B3C"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Ranking;
